import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Td, TextInput, Tr, useDebounce } from '@met/react-components';
import React, { Fragment, useEffect, useState } from 'react';

import { LinkButton } from '../../../components';
import { KeyColumn, ReferenceValueColumn } from './styled';

const TranslationRow = ({
  translation: {
    translationKey,
    translationKeyId,
    referenceValue,
    translationValue,
  },
  onUpdate,
  onDelete,
}) => {
  const [value, setValue] = useState(translationValue || '');
  const [dirty, setDirty] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);

  const debouncedValue = useDebounce(value, 500);
  const windowHash = window.location.hash;
  const elementHash = `#${translationKey}`;

  // When the value changes (debounced), call callback
  useEffect(() => {
    if (debouncedValue !== null && dirty) {
      setIsUpdating(true);
      onUpdate(translationKeyId, debouncedValue).then(() =>
        setIsUpdating(false)
      );
      setDirty(false);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedValue]);

  const handleChange = e => {
    setDirty(true);
    setValue(e.target.value);
  };

  const handleDelete = () => {
    onDelete(translationKeyId);
  };

  let rowStyle = {};
  if (windowHash && windowHash === elementHash) {
    rowStyle.backgroundColor = 'lightblue';
  }

  return (
    <Fragment>
      <Tr style={rowStyle}>
        <KeyColumn title={translationKey} data-label='Key' id={elementHash}>
          {translationKey}
        </KeyColumn>
        <ReferenceValueColumn data-label='Reference'>
          {referenceValue}
        </ReferenceValueColumn>
        <Td data-label='Translation'>
          <TextInput
            placeholder='Enter translation'
            value={value}
            onChange={handleChange}
            loading={isUpdating}
            multiline
            resizable
            rows={
              value.length > 250
                ? 10
                : value.length > 150
                ? 6
                : value.length > 40
                ? 5
                : 1
            }
          />
        </Td>
        <Td data-label='Actions'>
          <LinkButton onClick={handleDelete}>
            <FontAwesomeIcon icon='trash' />
          </LinkButton>
        </Td>
      </Tr>
    </Fragment>
  );
};

export default TranslationRow;
